import type { GetCourseDraftById200SectionsItemLecturesItemContentType } from './getCourseDraftById200SectionsItemLecturesItemContentType';
import type { GetCourseDraftById200SectionsItemLecturesItemPlatformSupport } from './getCourseDraftById200SectionsItemLecturesItemPlatformSupport';

/**
 * 강의 초안의 개별 강의(레슨) 상세 정보 (업데이트 요청 시 사용)
 */
export type GetCourseDraftById200SectionsItemLecturesItem = {
  /** 강의 콘텐츠 유형 */
  contentType: GetCourseDraftById200SectionsItemLecturesItemContentType;
  /**
   * 강의 시간 (초 단위)
   * @nullable
   */
  duration?: number | null;
  /**
   * 강의 ID (새로 생성 시 null 가능, 기존 ID는 Long)
   * @nullable
   */
  id?: number | null;
  /**
   * (새 강의 생성 시) 초기 마크다운 내용. 
기존 강의의 마크다운 업데이트는 /api/courses/drafts/{draftId}/lectures/{lectureId}/markdown API를 사용해야 합니다.
   * @nullable
   */
  markdownContent?: string | null;
  /**
   * 업로드된 마크다운 파일의 URL.
   * @nullable
   */
  markdownUrl?: string | null;
  /** 섹션 내 강의 순서 */
  order: number;
  /** 강의 콘텐츠 지원 플랫폼 환경 */
  platformSupport: GetCourseDraftById200SectionsItemLecturesItemPlatformSupport;
  /** 강의 제목 */
  title: string;
  /**
   * 비디오 콘텐츠 URL (있는 경우)
   * @nullable
   */
  videoUrl?: string | null;
};
